import { DEFAULT_CARDINALITY } from "../../../../../AppActor/actors/modellierungModel/helpers";
import type { LiteEigenschaft } from "../../../../../../lib/validation/lite/LiteSchemas";
import InfoRendererDisplay from "../../../../../InfoNodeEditView/InfoNodeEditForm/FormFieldRenderer/renderers/InfoRenderer/InfoRendererDisplay";
import type { DisplayRendererProps } from "../../types";

export default function KardinalitaetDisplay({
	activeNode,
}: DisplayRendererProps<LiteEigenschaft>): JSX.Element {
	return (
		<InfoRendererDisplay
			label="Kardinalität"
			value={activeNode.multiplizitaet}
			fallback={DEFAULT_CARDINALITY}
		/>
	);
}
